import React, {Component} from 'react';
import {connect} from 'react-redux';
import { push } from 'react-router-redux';
import api from '../api';

@connect(
    state => ({}),
    {push}
)
export default class ClientRedirect extends Component {

    componentDidMount() {
        api.get("/clients/from_fergus/" + this.props.params.id).then(response => {
            var clientId = response.value.id;
            console.log("Got client id", clientId);
            this.props.push(`/clients/${clientId}`);
        })
    }

    render() {      

        return (
            <div className="col-md-12">
                Redirecting... {this.props.params.id}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/pages/ClientRedirect.js